var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-content",
    [
      _c(
        "v-card",
        { staticClass: "primary lighten-1 white--text" },
        [
          _c(
            "v-container",
            { attrs: { fluid: "", "grid-list-sm": "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: "subheading white--text",
                          class: _vm.statusStyle,
                          attrs: { dense: "" }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("comment")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }, [
                            _vm._v(_vm._s(_vm.project.updateTimestamp))
                          ]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          !_vm.editUpdateOpen
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    right: "",
                                    flat: "",
                                    round: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editUpdateOpen = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { staticClass: "white--text" }, [
                                    _vm._v("add")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.editUpdateOpen
                        ? _c(
                            "v-list",
                            {
                              staticClass: "primary lighten-1 white--text",
                              attrs: { "two-line": "" }
                            },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          "\n                Update\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-sub-title",
                                        { staticClass: "update-text" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.project.updateText) +
                                              "                                            \n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editUpdateOpen
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _vm._v(
                                    "\n            New Update Date: " +
                                      _vm._s(_vm.todaysDate) +
                                      "\n            "
                                  ),
                                  _c(
                                    "v-form",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.projectStatuses,
                                          label: "New Project Update Status",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.project.updateStatus,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.project,
                                              "updateStatus",
                                              $$v
                                            )
                                          },
                                          expression: "project.updateStatus"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "New Project Update Text",
                                      "multi-line": ""
                                    },
                                    model: {
                                      value: _vm.project.updateText,
                                      callback: function($$v) {
                                        _vm.$set(_vm.project, "updateText", $$v)
                                      },
                                      expression: "project.updateText"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-card-actions",
                                    [
                                      _c("v-spacer"),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "hidden-xs-only",
                                          attrs: { flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.editUpdateOpen = false
                                            }
                                          }
                                        },
                                        [_vm._v("Cancel\n              ")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "hidden-xs-only",
                                          attrs: { flat: "" },
                                          on: {
                                            click: function($event) {
                                              _vm.pushProjectUpdate()
                                              _vm.editUpdateOpen = false
                                            }
                                          }
                                        },
                                        [_vm._v("Save\n              ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: " subheading",
                          class: _vm.statusStyle,
                          attrs: { dense: "" }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("business")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }),
                          _vm._v(" "),
                          _c("v-spacer")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        {
                          staticClass: "primary lighten-1 white--text",
                          attrs: { "three-line": "" }
                        },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "title" },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(_vm.project.cName) +
                                          "\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "subtitle" },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(_vm.project.name) +
                                          "\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-sub-title", [
                                    _vm._v(
                                      "\n                          Toggl Client ID: " +
                                        _vm._s(_vm.project.cid) +
                                        "                                            \n                      "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-sub-title", [
                                    _vm._v(
                                      "\n                          Toggl Project ID: " +
                                        _vm._s(_vm.project.id) +
                                        "                                            \n                      "
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md4: "" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          staticClass: " subheading",
                          class: _vm.statusStyle,
                          attrs: { dense: "" }
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("account_box")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-3" }),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          !_vm.editLeadOpen
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    icon: "",
                                    right: "",
                                    flat: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editLeadOpen = true
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { staticClass: "white--text" }, [
                                    _vm._v("mode_edit")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.editLeadOpen
                        ? _c(
                            "v-list",
                            {
                              staticClass: "primary lighten-1 white--text",
                              attrs: { "one-line": "" }
                            },
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "title" },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(_vm.project.leadName) +
                                              "\n                          "
                                          ),
                                          _c("v-list-item-action")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editLeadOpen
                        ? _c(
                            "v-card",
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-form",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.peopleEmails,
                                          label: "Project Lead",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.project.leadName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.project,
                                              "leadName",
                                              $$v
                                            )
                                          },
                                          expression: "project.leadName"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card-actions",
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "hidden-xs-only",
                                      attrs: { flat: "" },
                                      on: {
                                        click: function($event) {
                                          _vm.editLeadOpen = false
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Cancel\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "hidden-xs-only",
                                      attrs: { flat: "", disabled: false },
                                      on: {
                                        click: function($event) {
                                          _vm.updateProjectLead()
                                          _vm.editLeadOpen = false
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                      Save\n                      "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "", md4: "" } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41bd5494", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41bd5494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Project.vue
// module id = ZW1X
// module chunks = 1